export default "__VITE_ASSET__8KXh3qcE__"